<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>自動メールの編集</v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs10 md5>
              <v-select :items="adresss" v-model="value.to" label="送信先"></v-select>
            </v-flex>
            <v-flex xs10 md5>
              <v-select v-model="value.toStatus" :items="satatusList" label="送信先ステータス" :disabled="value.to=='企業担当者'"></v-select>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs10 md5>
              <v-select :items="scheduleDictionary" item-text='name' item-value='name' v-model="value.datetime" label="送信日時"></v-select>
            </v-flex>
          </v-layout>
          <v-text-field label="件名" v-model="value.subject"></v-text-field>
          <v-textarea v-model="value.body" label="本文" auto-grow></v-textarea>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close">キャンセル</v-btn>
        <v-btn v-if="action == 'add'" @click="addItem">追加</v-btn>
        <v-btn v-if="action == 'update'" @click="updateItem">更新</v-btn>
        <!-- <v-btn @click="updateItem(true)">メール作成</v-btn> -->
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    value: {
      type: Object,
      default: null
    },
    action: {
      type: String,
      default: "update"
    },
    scheduleDictionary: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      adresss: ["全回答者", "対象者", "協力者", "企業担当者"],
      satatusList: ["全て", "未提出", "提出済"],
      datetimeList: [
        "メール受信テスト",
        "サーベイ配信",
        "未回答者リマインド",
        "一次締切",
        "最終締切"
      ]
    };
  },
  watch: {},
  computed: {},
  methods: {
    close() {
      this.$emit("closeDialog");
    },
    addItem() {
      this.$emit("createItem");
    },
    updateItem() {
      this.$emit("updateItem");
    }
  }
};
</script>

<style lang="scss" scoped>
</style>